export default "__VITE_ASSET__3cd62f04__"